// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2bxu_","amount":"Amount_amount__bv9X9","tip":"Amount_tip__TTK90","tipHeader":"Amount_tipHeader__2xlLM","tipsWrap":"Amount_tipsWrap__2oM__"};